import { render, staticRenderFns } from "./crypto-detail-layout.vue?vue&type=template&id=8ec59ca6&"
import script from "./crypto-detail-layout.vue?vue&type=script&lang=js&"
export * from "./crypto-detail-layout.vue?vue&type=script&lang=js&"
import style0 from "./crypto-detail-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/Header.vue').default,Footer: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/Footer.vue').default})
